import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { RatesFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkRatesPOSTErrorResponse, ParkRatesPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchRates = async (): Promise<ParkRatesPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkRatesPOSTSuccessResponse>("/rates");
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkRatesPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: RatesFailReason };
  }
};
